$(document).ready(function(){
    /*
     * Top screen
     */
    $('.ns-section_main-slider1').each(function(){
        const $swiper = $(this).find('.swiper'),
            swiper = new Swiper($swiper[0], {
                slidesPerView: 1,
                pagination: {
                    el: $swiper.find('.swiper-pagination')[0],
                    clickable: true,
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                speed: 600,
            }), $canvas = $(this).find('canvas'),
            $wrap  = $(this),
            canvas = $canvas[0],
            ctx = canvas.getContext("2d");

        /*
         * Пропорция ромба из макета: 1075x878 при обёртке 1320x976.
         * Держим её постоянной, чтобы форма не зависела от высоты окна.
         */
        const SQUARE_RATIO = 1075 / 878,
            SQUARE_MAX_WIDTH = 1344,
            SHAPE_COLOR = '#691a28';

        const init = () => {
            let points = [
                { x: 0.50, y: 0.05 },
                { x: 0.97, y: 0.57 },
                { x: 0.35, y: 0.9 },
                { x: 0.1, y: 0.42 }
            ], cursorPosX = null, cursorPosY = null, globalOffsetX = 0, globalOffsetY = 0;

            if ($(window).outerWidth() < 768) {
                points = [
                    { x: 0.93, y: 0.02 },
                    { x: 1.1, y: 0.8 },
                    { x: 0.1, y: 0.95 },
                    { x: -0.1, y: 0.2 }
                ];
            } else if ($(window).outerWidth() < 992){
                points = [
                    { x: 0.70, y: 0 },
                    { x: 1.05, y: 0.6 },
                    { x: 0.1, y: 0.9 },
                    { x: -0.1, y: 0.3 }
                ];
            }

            if ($(window).outerWidth() > 1919){
                points = [
                    { x: 0.55, y: 0 },
                    { x: 1, y: 0.6 },
                    { x: 0.3, y: 0.95 },
                    { x: 0.05, y: 0.35 }
                ];
            }

            const animatedPoints = points.map(point => ({ ...point, dx: 0, dy: 0 }));

            $(document).mousemove(function(e) {
                const blockOffset = $wrap.offset();
                const blockWidth = $wrap.outerWidth();
                const blockHeight = $wrap.outerHeight();

                const centerX = blockOffset.left + blockWidth / 2;
                const centerY = blockOffset.top + blockHeight / 2;

                const cursorX = e.pageX;
                const cursorY = e.pageY;


                if (cursorY < centerY) {
                    cursorPosY = 'top';
                } else if (cursorY > centerY) {
                    cursorPosY = 'bottom';
                }

                if (cursorX < centerX) {
                    cursorPosX = 'left';
                } else if (cursorX > centerX) {
                    cursorPosX = 'right';
                }
            });

            const lerp = (start, end, t) => start + (end - start) * t;

            const updateGlobalOffsets = () => {
                let targetGlobalX = 0;
                let targetGlobalY = 0;

                if (cursorPosX === 'left') {
                    targetGlobalX = -0.005;
                } else if (cursorPosX === 'right') {
                    targetGlobalX = 0.005;
                }

                if (cursorPosY === 'top') {
                    targetGlobalY = -0.005;
                } else if (cursorPosY === 'bottom') {
                    targetGlobalY = 0.005;
                }

                // Плавный переход для глобального смещения
                globalOffsetX = lerp(globalOffsetX, targetGlobalX, 0.05);
                globalOffsetY = lerp(globalOffsetY, targetGlobalY, 0.05);
            };

            const updatePoints = () => {
                updateGlobalOffsets();

                animatedPoints.forEach((point, i) => {
                    // Плавное изменение локальных точек
                    point.dx = lerp(point.dx, Math.sin(Date.now() / 500 + i) * 0.005 + globalOffsetX, 0.1);
                    point.dy = lerp(point.dy, Math.cos(Date.now() / 700 + i) * 0.005 + globalOffsetY, 0.1);
                });
            };

            /*
             * Размер ромба берём от ширины обёртки и держим пропорцию макета.
             * Высота участвует только как ограничитель: если ромб в неё не влезает,
             * он уменьшается целиком, а не сплющивается.
             */
            const getShapeGeometry = () => {
                const wrapWidth  = $wrap.width(),
                    wrapHeight = $wrap.height();

                let squareWidth, squareHeight;

                if (wrapWidth < 768) {
                    // На мобиле высота секции фиксирована в css, привязка к ней безопасна
                    squareWidth  = 1075 / 1320 * wrapWidth;
                    squareHeight = 878 / 976 * wrapHeight;
                } else {
                    const maxWrapWidth = Math.min(wrapWidth, SQUARE_MAX_WIDTH);

                    // Ширина всегда от ширины экрана и не уменьшается: от неё зависит,
                    // влезет ли текст в ромб
                    squareWidth = 1075 / 1320 * maxWrapWidth;

                    // Высота — не больше пропорции макета, чтобы на высоких экранах
                    // ромб не вытягивался вверх и не вылезал за секцию
                    squareHeight = Math.min(squareWidth / SQUARE_RATIO, 878 / 976 * wrapHeight);
                }

                return {
                    squareWidth: squareWidth,
                    squareHeight: squareHeight,
                    centerX: (wrapWidth - squareWidth) / 2,
                    centerY: (wrapHeight - squareHeight) / 2
                };
            };

            const calculateScaledPoints = () => {
                const geometry = getShapeGeometry();

                return animatedPoints.map(point => ({
                    x: geometry.centerX + (point.x + point.dx) * geometry.squareWidth,
                    y: geometry.centerY + (point.y + point.dy) * geometry.squareHeight
                }));
            };

            /*
             * Отдаём в css верхнюю вершину и высоту ромба, чтобы картинки слайдов
             * начинались от неё и были одной высоты на всех баннерах.
             */
            const publishShapeVars = () => {
                const geometry = getShapeGeometry(),
                    ys = points.map(point => point.y),
                    minY = Math.min.apply(null, ys),
                    maxY = Math.max.apply(null, ys);

                $wrap[0].style.setProperty('--shape-top', (geometry.centerY + minY * geometry.squareHeight) + 'px');
                $wrap[0].style.setProperty('--shape-height', ((maxY - minY) * geometry.squareHeight) + 'px');
            };

            const draw = function () {
                canvas.width = $wrap.width();
                canvas.height = $wrap.height();

                const scaledPoints = calculateScaledPoints();

                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(scaledPoints[0].x, scaledPoints[0].y);

                scaledPoints.forEach(point => {
                    ctx.lineTo(point.x, point.y);
                });

                ctx.closePath();
                ctx.clip();

                // Бордовый фон одинаковый на всех баннерах
                ctx.fillStyle = SHAPE_COLOR;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.restore();

                updatePoints();
            };

            const loop = function () {
                draw();
                requestAnimationFrame(loop);
            };

            publishShapeVars();
            loop();

            $(window).on('resize', publishShapeVars);

            let animTimeout = null, previousIndex  = 0;

            swiper.on('slideChange', function () {
                const nextSlide = this.slides[this.activeIndex],
                    currentIndex = this.realIndex;

                let additionClass= '_anim-right';

                if (currentIndex > previousIndex) {
                    additionClass = '_anim-right';
                } else if (currentIndex < previousIndex) {
                    additionClass = '_anim-left';
                }

                previousIndex = currentIndex;

                $swiper.find('.swiper-slide').removeClass('_anim _anim-right _anim-left');
                $(nextSlide).addClass('_anim ' + additionClass);

                if (animTimeout != null){
                    clearTimeout(animTimeout);
                    animTimeout = null;
                }

                setTimeout(function(){
                    $(nextSlide).removeClass('_anim _anim-right _anim-left');
                }, 800);
            });

            $('.ns-section_main-slider1__video').each(function () {
                const $wrap = $(this), isMobile = $(window).outerWidth() < 768;
                const $video = $(this).find(!isMobile ? 'video:eq(0)' : 'video:eq(1)'),
                    video = $video[0];

                const $controls = $(this).find('.ns-section_main-slider1__video-controls');

                let isDragging = false;

                const formatTime = function (seconds) {
                    const minutes = Math.floor(seconds / 60);
                    const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
                    return `${minutes}:${secs}`;
                }

                $controls.on('click', '._play', function () {
                    console.log(video.paused, video.ended);

                    if (video.paused || video.ended) {
                        setTimeout(function () {
                            if (video.paused || video.ended) {
                                video.play();
                            }
                        }, 50);
                        $controls.find('._play').hide();
                        $controls.find('._stop').show();
                    } else {
                        setTimeout(function () {
                            if (!video.paused && !video.ended) {
                                video.pause();
                            }
                        }, 50);
                        $controls.find('._play').show();
                        $controls.find('._stop').hide();
                    }
                }).on('click', '._stop', function () {
                    console.log(video.paused, video.ended);
                    if (!video.paused && !video.ended) {
                        setTimeout(function () {
                            if (!video.paused && !video.ended) {
                                video.pause();
                            }
                        }, 50);
                        $controls.find('._play').show();
                        $controls.find('._stop').hide();
                    }
                }).on('click', '._mute', function () {
                    video.muted = !video.muted;
                    $(this).toggleClass('_active', video.muted);
                }).on('click touchstart', '._seek-bar', function (e) {
                    var clientX;

                    if (e.type === 'touchstart') {
                        clientX = e.originalEvent.touches[0].clientX;
                    } else {
                        clientX = e.clientX;
                    }

                    var rect = this.getBoundingClientRect();
                    var offsetX = clientX - rect.left;
                    var progress = offsetX / rect.width;

                    video.currentTime = progress * video.duration;
                }).on('mousedown', '._seek-bar svg', function () {
                    isDragging = true;
                });

                $(document).on('mousemove', function (e) {
                    if (isDragging) {
                        const rect = $controls.find('._seek-bar')[0].getBoundingClientRect();
                        const offsetX = Math.min(Math.max(e.clientX - rect.left, 0), rect.width);
                        const progress = offsetX / rect.width;
                        $controls.find('._seek-bar span').css('width', `${progress * 100}%`);
                        $controls.find('._seek-bar svg').css('left', `${progress * 100}%`);
                        video.currentTime = progress * video.duration;
                    }
                }).on('mouseup', function () {
                    if (isDragging) {
                        isDragging = false;
                        const rect = $controls.find('._seek-bar')[0].getBoundingClientRect();
                        const offsetX = Math.min(Math.max(e.clientX - rect.left, 0), rect.width);
                        const progress = offsetX / rect.width;
                        $controls.find('._seek-bar span').css('width', `${progress * 100}%`);
                        $controls.find('._seek-bar svg').css('left', `${progress * 100}%`);
                        video.currentTime = progress * video.duration;
                    }
                });

                $video.on('loadedmetadata', function (e) {
                    $controls.find('._time span:eq(2)').text(formatTime(video.duration));
                }).on('timeupdate', function () {
                    if (video.ended) {
                        video.currentTime = 0;
                        setTimeout(function () {
                            if (!video.paused && !video.ended) {
                                video.pause();
                            }
                        }, 50);
                        $controls.find('._play').show();
                        $controls.find('._stop').hide();
                    }

                    const $product = $wrap.find('.ns-section_main-slider1__video-product');

                    $product.removeClass('_show');

                    if ((video.currentTime > 18 && video.currentTime < 38) || (video.currentTime > 44 && video.currentTime < 50)){
                        $product.filter('[data-type="first"]').addClass('_show');
                    } else if (video.currentTime > 38 && video.currentTime < 45){
                        $product.filter('[data-type="second"]').addClass('_show');
                    }

                    const progress = (video.currentTime / video.duration) * 100;

                    if (!isDragging) {
                        $controls.find('._seek-bar span').css('width', `${progress}%`);
                        $controls.find('._seek-bar svg').css('left', `${progress}%`);
                    }

                    $controls.find('._time span:eq(0)').text(formatTime(video.currentTime));
                    $controls.find('._time span:eq(2)').text(formatTime(video.duration));
                });

                $('.js-ns-main-video-toggle').click(function () {
                    $wrap.toggleClass('_active');

                    if ($wrap.hasClass('_active')) {
                        setTimeout(function () {
                            if (video.paused || video.ended) {
                                video.play();
                            }
                        }, 50);
                        $controls.find('._play').hide();
                        $controls.find('._stop').show();
                        swiper.autoplay.stop();
                        $wrap.closest('.swiper').addClass('swiper_video');
                    } else {
                        video.currentTime = 0;
                        setTimeout(function () {
                            if (!video.paused && !video.ended) {
                                video.pause();
                            }
                        }, 50);
                        $controls.find('._play').show();
                        $controls.find('._stop').hide();
                        swiper.autoplay.start();
                        $wrap.closest('.swiper').removeClass('swiper_video');
                    }
                });
            });
        };

        init();
    });

    $('.ns-section_main-slider2').each(function(){
        const $wrap  = $(this).find('.container'),
            $swiper = $(this).find('.swiper');

        let cursorPosX = null, cursorPosY = null, globalOffsetX = 0, globalOffsetY = 0;

        const lerp = (start, end, t) => start + (end - start) * t;

        const slidesData = [
            {
                image: '/img/ns/home/slider2_1_1.jpg',
                fill: '#C38F4B',
                opacity: 0.8,
                effect: 'multiply',
            },
            {
                image: '/img/ns/home/slider2_2_1.jpg',
                fill: '#1E3D4F',
                opacity: 0.8,
                effect: 'color-burn',
            },
            {
                image: '/img/ns/home/slider2_3.jpg',
                fill: '#730F26',
                opacity: 1.0,
                effect: 'multiply',
            },
            {
                image: '/img/ns/home/slider2_4.jpg',
                fill: '#C38F4B',
                opacity: 0.8,
                effect: 'multiply',
            },
        ];

        $(document).mousemove(function(e) {
            const blockOffset = $wrap.offset();
            const blockWidth = $wrap.width();
            const blockHeight = $wrap.height();

            const centerX = blockOffset.left + blockWidth / 2;
            const centerY = blockOffset.top + blockHeight / 2;

            const cursorX = e.pageX;
            const cursorY = e.pageY;

            if (cursorY < centerY) {
                cursorPosY = 'top';
            } else if (cursorY > centerY) {
                cursorPosY = 'bottom';
            }

            if (cursorX < centerX) {
                cursorPosX = 'left';
            } else if (cursorX > centerX) {
                cursorPosX = 'right';
            }
        });

        const swiper = new Swiper($swiper[0], {
            loop: 0,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
        });

        const $slide  = $(this),
            $canvas = $(this).find('canvas'),
            canvas = $canvas[0],
            ctx = canvas.getContext("2d");

        const images = [];

        for (let i in slidesData){
            const img = new Image();
            img.src = slidesData[i].image;
            images.push(img);
        }

        images[0].onload = () => {
            canvas.width = $wrap.width();
            canvas.height = $wrap.height();

            let squareWidth = 1075 / 1320 * $wrap.width();
            let squareHeight= 878 / 976 * $wrap.height();

            let points = [
                { x: 0.32, y: 0 },
                { x: 0.95, y: 0.4 },
                { x: 0.57, y: 1 },
                { x: 0.05, y: 0.65 }
            ];

            if ($(window).outerWidth() < 575) {
                squareWidth = 400;
                squareHeight = 400;
            } else if ($(window).outerWidth() < 768){
                points = [
                    { x: 0.4, y: 0.2 },
                    { x: 1.1, y: 0.4 },
                    { x: 0.6, y: 0.85 },
                    { x: -0.1, y: 0.6 }
                ];
            }

            const animatedPoints = points.map(point => ({ ...point, dx: 0, dy: 0 }));

            const updateGlobalOffsets = () => {
                let targetGlobalX = 0;
                let targetGlobalY = 0;

                if (cursorPosX === 'left') {
                    targetGlobalX = -0.005;
                } else if (cursorPosX === 'right') {
                    targetGlobalX = 0.005;
                }

                if (cursorPosY === 'top') {
                    targetGlobalY = -0.005;
                } else if (cursorPosY === 'bottom') {
                    targetGlobalY = 0.005;
                }

                // Плавный переход для глобального смещения
                globalOffsetX = lerp(globalOffsetX, targetGlobalX, 0.05);
                globalOffsetY = lerp(globalOffsetY, targetGlobalY, 0.05);
            };

            const updatePoints = () => {
                updateGlobalOffsets();

                animatedPoints.forEach((point, i) => {
                    // Плавное изменение локальных точек
                    point.dx = lerp(point.dx, Math.sin(Date.now() / 500 + i) * 0.005 + globalOffsetX, 0.1);
                    point.dy = lerp(point.dy, Math.cos(Date.now() / 700 + i) * 0.005 + globalOffsetY, 0.1);
                });
            };

            const calculateScaledPoints = () => {
                const centerX = (canvas.width - squareWidth) / 2;
                const centerY = (canvas.height - squareHeight) / 2;
                return animatedPoints.map(point => ({
                    x: centerX + (point.x + point.dx) * squareWidth,
                    y: centerY + (point.y + point.dy) * squareHeight
                }));
            };

            const drawImageCover = function(ctx, img, rectX, rectY, rectWidth, rectHeight) {
                const imgRatio = img.width / img.height; // Соотношение сторон изображения
                const rectRatio = rectWidth / rectHeight; // Соотношение сторон прямоугольника

                let drawWidth, drawHeight;

                if (imgRatio > rectRatio) {
                    // Изображение шире прямоугольника
                    drawWidth = rectHeight * imgRatio;
                    drawHeight = rectHeight;
                } else {
                    // Изображение выше прямоугольника
                    drawWidth = rectWidth;
                    drawHeight = rectWidth / imgRatio;
                }

                const offsetX = rectX - (drawWidth - rectWidth) / 2; // Смещение по горизонтали
                const offsetY = rectY - (drawHeight - rectHeight) / 2; // Смещение по вертикали

                ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            };

            const draw = function () {
                const scaledPoints = calculateScaledPoints();

                ctx.globalCompositeOperation = 'source-over';
                ctx.globalAlpha = 1;
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                drawImageCover(ctx, images[swiper.activeIndex], 0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'color-dodge';

                const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
                gradient.addColorStop(0, 'rgba(147, 197, 222, 0.3)');
                gradient.addColorStop(1, 'rgba(79, 106, 120, 0.3)');

                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = slidesData[swiper.activeIndex].effect;
                ctx.globalAlpha = slidesData[swiper.activeIndex].opacity;

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(scaledPoints[0].x, scaledPoints[0].y);

                scaledPoints.forEach(point => {
                    ctx.lineTo(point.x, point.y);
                });

                ctx.closePath();
                ctx.clip();

                ctx.fillStyle = slidesData[swiper.activeIndex].fill;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'source-over';
                ctx.globalAlpha = 1;
                ctx.restore();

                updatePoints();

                requestAnimationFrame(draw);
            };

            draw();
        };

        let animTimeout = null, previousIndex = 0;

        swiper.on('slideChange', function () {
            const nextSlide = this.slides[this.activeIndex],
                currentIndex = this.realIndex;

            let additionClass= '_anim-right';

            if (currentIndex > previousIndex) {
                additionClass = '_anim-right';
            } else if (currentIndex < previousIndex) {
                additionClass = '_anim-left';
            }

            previousIndex = currentIndex;

            $swiper.find('.swiper-slide').removeClass('_anim _anim-right _anim-left');
            $(nextSlide).addClass('_anim ' + additionClass);

            if (animTimeout != null){
                clearTimeout(animTimeout);
                animTimeout = null;
            }

            setTimeout(function(){
                $(nextSlide).removeClass('_anim _anim-right _anim-left');
            }, 800);
        });
    });

    $('.ns-section_main-top').each(function(){
        const $wrap = $(this).find('.ns-section_main-top__slider'),
            $swiper = $(this).find('.swiper');

        const swiper = new Swiper($swiper[0], {
            loop: true,
            centeredSlides: true,
            centeredSlidesBounds: true,
            slidesPerView: 3,
            spaceBetween: 20,
            breakpoints: {
                768 : {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1200 : {
                    slidesPerView: 5,
                    spaceBetween: 40,
                },
            },
            navigation: {
                nextEl: $(this).find('.swiper-button-next')[0],
                prevEl: $(this).find('.swiper-button-prev')[0],
            },
        });

        swiper.on('touchStart slideChangeTransitionStart', function(){
            $wrap.addClass('_move');
        });

        swiper.on('touchEnd slideChangeTransitionEnd', function(){
            $wrap.removeClass('_move');
        });
    });

    $('.ns-section_main-categories').each(function () {
        const $wrap = $(this);

        $(this).on('click', '.ns-section_main-categories__slide', function () {
            const $this = $(this);

            if (!$this.hasClass('_active') && !$wrap.hasClass('_loading')) {
                const $active = $this.parent().children('._active');

                let timeout= 700;

                if ($(window).outerWidth() < 767){
                    timeout = 0;
                }

                $this.find('.ns-section_main-categories__slide-wrap')
                    .width($active.outerWidth());

                $active.find('img, .ns-section_main-categories__slide-arrows').css({
                    opacity: 0
                });
                $this.find('img, .ns-section_main-categories__slide-arrows').removeAttr('style');

                $active.addClass('_hide-anim');
                $this.addClass('_active');
                $wrap.addClass('_loading');

                setTimeout(function () {
                    $active.removeClass('_hide-anim').removeClass('_active');
                    $wrap.removeClass('_loading');
                    $this.find('.ns-section_main-categories__slide-wrap').removeAttr('style');
                }, timeout);
            }
        }).on('click', '.ns-section_main-categories__slide-arrows div', function (e) {
            e.preventDefault();

            const index = $(this).index(), slideIndex = $(this).parents('.ns-section_main-categories__slide').index(),
                $wrap = $(this).parents('.ns-section_main-categories'),
                slideCounts = $wrap.find('.ns-section_main-categories__slide').length;

            if (index === 0) {
                //left
                if (slideIndex === 0) {
                    $wrap.find('.ns-section_main-categories__slide:last').click();
                } else {
                    $wrap.find('.ns-section_main-categories__slide:eq(' + (slideIndex - 1) + ')').click();
                }
            } else {
                //right
                if (slideIndex === slideCounts - 1) {
                    $wrap.find('.ns-section_main-categories__slide:first').click();
                } else {
                    $wrap.find('.ns-section_main-categories__slide:eq(' + (slideIndex + 1) + ')').click();
                }
            }

            return false;
        });
    });
});
